export const accessabilityLabels = {
  firstname: 'given-name',
  lastname: 'family-name',
  password: 'current-password',
  email: 'email',
  telephone1: 'tel',
  telephone2: 'tel',
  telephone3: 'tel',
  address1: 'street-address',
  address2: 'street-address',
  zip: 'postal-code',
  city: 'address-level2',
  countryId: 'country',
  name: 'organization',
  title: 'organization-title',
  url: 'url',
} as const;
